import { render, staticRenderFns } from "./notification-container.vue?vue&type=template&id=68d6c0ce&scoped=true"
import script from "./notification-container.vue?vue&type=script&lang=ts"
export * from "./notification-container.vue?vue&type=script&lang=ts"
import style0 from "./notification-container.vue?vue&type=style&index=0&id=68d6c0ce&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d6c0ce",
  null
  
)

export default component.exports